import { render } from "./WithdrawAmountForm.vue?vue&type=template&id=28b91a70&scoped=true"
import script from "./WithdrawAmountForm.vue?vue&type=script&lang=js"
export * from "./WithdrawAmountForm.vue?vue&type=script&lang=js"

import "./WithdrawAmountForm.vue?vue&type=style&index=0&id=28b91a70&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b91a70"]])

export default __exports__